/* Glow Wash PDP (Smooche layout): carousel arrows, review "Read More", badge close, scroll-to-offer. */
(() => {
  if (window.__smcPdp) return;
  window.__smcPdp = true;
  const decodeReviews = (b64) => {
    try {
      const bin = atob(b64);
      const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
      const data = JSON.parse(new TextDecoder().decode(bytes));
      return (data && data.reviews) || [];
    } catch (e) {
      return [];
    }
  };
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pickReviews = (list, max) =>
    list
      .filter((r) => Number(r.rating) === 5 && r.has_content && (r.review || '').trim().length >= 40 && !r.is_spam)
      .sort((a, b) => (b.has_photo ? 1 : 0) - (a.has_photo ? 1 : 0) || (b.is_pinned ? 1 : 0) - (a.is_pinned ? 1 : 0))
      .slice(0, max);
  const renderReviews = () => {
    document.querySelectorAll('[data-smc-reviews]').forEach((track) => {
      if (track.dataset.rendered) return;
      track.dataset.rendered = '1';
      const reviews = pickReviews(decodeReviews(track.dataset.smcReviews), Number(track.dataset.smcMax) || 6);
      const section = track.closest('.smc');
      if (!reviews.length) {
        if (section) section.style.display = 'none';
        return;
      }
      track.innerHTML = reviews
        .map((r) => {
          const photo = (r.photosArray || [])[0];
          return `<article class="smc-review">${photo ? `<img class="smc-review__img" src="${esc(photo)}" alt="${esc(r.author)}" loading="lazy" width="600" height="554" onerror="this.remove()">` : ''}<div class="smc-review__body"><div class="smc-review__head"><span>${esc(r.author)}</span><span class="smc-review__stars">★★★★★</span></div><p class="smc-review__meta">Customer review</p><p class="smc-review__quote">"${esc(r.review.trim())}"</p><button type="button" class="smc-review__more">Read More</button></div></article>`;
        })
        .join('');
      document.querySelectorAll('[data-smc-proof]').forEach((el) => {
        const total = Number(el.dataset.total) || 0;
        const first = reviews[0];
        if (!first || total < 2) return;
        const initials = reviews.slice(0, 3).map((r) => `<span>${esc((r.author || '?').trim().charAt(0).toUpperCase())}</span>`).join('');
        el.innerHTML = `<span class="smc-avatars">${initials}</span><span><strong>${esc(first.author.trim())}</strong><span class="smc-verified" aria-hidden="true"></span> and ${(total - 1).toLocaleString()} others reviewed it</span>`;
        el.hidden = false;
      });
    });
  };

  const init = () => {
    renderReviews();
    document.querySelectorAll('.smc-carousel').forEach((c) => {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      const track = c.querySelector('.smc-track');
      const prev = c.querySelector('.smc-arrow--prev');
      const next = c.querySelector('.smc-arrow--next');
      if (!track) return;
      const step = (dir) => {
        const item = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: dir * ((item ? item.offsetWidth : track.clientWidth) + gap), behavior: 'smooth' });
      };
      const update = () => {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev && prev.addEventListener('click', () => step(-1));
      next && next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
    document.querySelectorAll('.smc-review__more').forEach((b) => {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', () => {
        const card = b.closest('.smc-review');
        card.classList.toggle('is-open');
        b.textContent = card.classList.contains('is-open') ? 'Read Less' : 'Read More';
      });
    });
    document.querySelectorAll('.smc-badge__close').forEach((b) => {
      b.addEventListener('click', () => b.closest('.smc-badge').remove());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
